import type { ComboboxOption } from '../types/ComboboxOption';

type ComboboxValue<T extends string> = T | ComboboxOption<T>;

export function extendOptionsWithValues<T extends string>(
  options: ComboboxOption<T>[],
  value?: ComboboxValue<T> | ComboboxValue<T>[],
): ComboboxOption<T>[] {
  if (
    !value ||
    (Array.isArray(value) && typeof value[0] === 'string') ||
    typeof value === 'string'
  ) {
    return options;
  }

  const result = [...options];
  const newOptions = (
    Array.isArray(value) ? value : [value]
  ) as ComboboxOption<T>[];

  for (const option of newOptions) {
    if (!options.some((o) => o.value === option.value)) {
      result.push(option);
    }
  }

  return result;
}
